import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

export const StyledMessage = styled.p`
  ${pickThemeFontStyles('14', '20')}
  color: ${COLORS.TEXT_PRIMARY};
  margin: 0;
`;

export const StyledFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
`;
